"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.ACTIONS = exports.removeBase64Prefix = exports.unregisterNativeCallback = exports.registryNativeCallback = exports.nativeAdaptor = exports.initNativeListener = exports.getHllUserInfo = exports.share = exports.updateNavLeftBtnCallbackCode = exports.toHomeworkComment = exports.logout = exports.toNextPage = exports.fullScreen = exports.closeWeb = void 0;

var const_1 = require("./const");

Object.defineProperty(exports, "ACTIONS", {
  enumerable: !0,
  get: function get() {
    return const_1.ACTIONS;
  }
});

var core_1 = require("./core");

Object.defineProperty(exports, "initNativeListener", {
  enumerable: !0,
  get: function get() {
    return core_1.initNativeListener;
  }
}), Object.defineProperty(exports, "nativeAdaptor", {
  enumerable: !0,
  get: function get() {
    return core_1.nativeAdaptor;
  }
}), Object.defineProperty(exports, "registryNativeCallback", {
  enumerable: !0,
  get: function get() {
    return core_1.registryNativeCallback;
  }
}), Object.defineProperty(exports, "unregisterNativeCallback", {
  enumerable: !0,
  get: function get() {
    return core_1.unregisterNativeCallback;
  }
});

var utils_1 = require("./utils");

Object.defineProperty(exports, "removeBase64Prefix", {
  enumerable: !0,
  get: function get() {
    return utils_1.removeBase64Prefix;
  }
});

var closeWeb = function closeWeb() {
  return (0, core_1.nativeAdaptor)({
    actionName: const_1.ACTIONS.closeWeb
  });
};

exports.closeWeb = closeWeb;

var fullScreen = function fullScreen(e) {
  return (0, core_1.nativeAdaptor)({
    actionName: const_1.ACTIONS.fullScreen,
    actionParams: {
      url: e
    }
  });
};

exports.fullScreen = fullScreen;

var toNextPage = function toNextPage(e) {
  return (0, core_1.nativeAdaptor)({
    actionName: const_1.ACTIONS.toNextPage,
    actionParams: {
      url: e
    }
  });
};

exports.toNextPage = toNextPage;

var logout = function logout() {
  return (0, core_1.nativeAdaptor)({
    actionName: const_1.ACTIONS.logout
  });
};

exports.logout = logout;

var toHomeworkComment = function toHomeworkComment(e) {
  return (0, core_1.nativeAdaptor)({
    actionName: const_1.ACTIONS.toHomeworkComment,
    actionParams: e
  });
};

exports.toHomeworkComment = toHomeworkComment;

var updateNavLeftBtnCallbackCode = function updateNavLeftBtnCallbackCode(e, t) {
  return (0, core_1.nativeAdaptor)({
    actionName: const_1.ACTIONS.updateNavLeftBtnCallbackCode,
    actionParams: e,
    callBackName: "leftBtnCallback",
    callback: t
  });
};

exports.updateNavLeftBtnCallbackCode = updateNavLeftBtnCallbackCode;

var share = function share(e, t) {
  e.imageBase64 && (e.imageBase64 = (0, utils_1.removeBase64Prefix)(e.imageBase64));
  var r = (0, core_1.nativeAdaptor)({
    actionName: const_1.ACTIONS.share,
    actionParams: e,
    callBackName: "shareCallback",
    callback: function callback() {
      for (var e = [], o = 0; o < arguments.length; o++) {
        e[o] = arguments[o];
      }

      t && t.apply(void 0, e), r && r();
    }
  });
  return r;
};

exports.share = share;

var getHllUserInfo = function getHllUserInfo(e) {
  return (0, core_1.nativeAdaptor)({
    actionName: const_1.ACTIONS.getHllUserInfo,
    callBackName: "hllUserInfo",
    callback: function callback(t) {
      e && e(t);
    }
  });
};

exports.getHllUserInfo = getHllUserInfo;